import { ApolloLink, Observable } from '@apollo/client';
import { increment, decrement } from '../../actions/loading';
import { pushError } from '../../actions/errors';

export default class PendingRequestCounterLink extends ApolloLink {
  store;

  request(operation, forward) {
    this.store.dispatch(increment());

    const subscriber = forward(operation);

    return new Observable((observer) => {
      const subscription = subscriber.subscribe({
        next: (result) => {
          this.dispatchErrors(result);
          observer.next(result);
          this.store.dispatch(decrement());
        },
        error: (networkError) => {
          this.dispatchErrors(networkError.result);
          observer.error(networkError);
          this.store.dispatch(decrement());
        },
        complete: (result) => {
          this.store.dispatch(decrement());
          observer.complete(result);
        },
      });

      return () => {
        if (subscription) subscription.unsubscribe();
      };
    });
  }

  dispatchErrors(result) {
    if (result && result.errors) {
      result.errors.forEach((e) => {
        this.store.dispatch(pushError(e));
      });
    }
  }

  connect(store) {
    this.store = store;
  }
}
